"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
require("./packageBouttonStyle.css");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function BoutonFiltre(_ref) {
  let {
    id,
    couleur,
    titre,
    fonctions,
    image
  } = _ref;
  const [checked, setChecked] = (0, _react.useState)(false);
  const myInput = (0, _react.useRef)(null);
  function changeStatusChecked() {
    if (!myInput.current.checked) {
      myInput.current.checked = true;
      setChecked(false);
    } else {
      myInput.current.checked = false;
      setChecked(true);
    }
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ButtonContaineur",
    onClick: () => {
      changeStatusChecked();
      fonctions.map(func => {
        func(id, couleur, titre);
      });
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "containeur_logo"
  }, couleur && /*#__PURE__*/_react.default.createElement("span", {
    style: {
      backgroundColor: couleur
    },
    className: "ButtonContaineur__SpanColor"
  }), image && /*#__PURE__*/_react.default.createElement("img", {
    src: image,
    alt: "icone"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "ButtonContaineur__SpanTrait"
  }), /*#__PURE__*/_react.default.createElement("label", {
    className: "ButtonContaineur__Checkbox"
  }, /*#__PURE__*/_react.default.createElement("input", {
    ref: myInput,
    defaultChecked: true,
    className: "ButtonContaineur__Checkbox__Input",
    type: "checkbox",
    disabled: true
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "ButtonContaineur__Checkbox__Span"
  })), /*#__PURE__*/_react.default.createElement("p", {
    className: checked ? "ButtonContaineur__Texte--unChecked" : "ButtonContaineur__Texte--checked"
  }, titre.toUpperCase()));
}
var _default = BoutonFiltre;
exports.default = _default;